module.exports = __webpack_public_path__ + "static/img/19.91007232.png";